import {
    AutocompleteInput,
    Create,
    DateInput,
    ReferenceInput,
    SimpleForm,
    TextInput,
} from '@/components/admin';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Calendar, Settings } from 'lucide-react';
import { required } from 'ra-core';
import { AutoReferenceField } from '../documents/shared/AutoReferenceField';
import { PrioritySelectInput } from '../documents/shared/StatusSelectInput';

export const WorkOrderCreate = () => (
    <Create title="Create Work Order">
        <SimpleForm className="w-full space-y-6">
            <Card className="w-full shadow-sm">
                <CardHeader className="pb-3 border-b bg-muted/50">
                    <div className="flex items-center gap-2">
                        <Settings className="w-5 h-5 text-muted-foreground" />
                        <CardTitle className="text-lg font-semibold tracking-tight">Work Order Details</CardTitle>
                    </div>
                </CardHeader>
                <CardContent className="pt-6">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                        <AutoReferenceField docType="work_order" />
                        <ReferenceInput source="project_id" reference="projects">
                            <AutocompleteInput label="Project" validate={required()} className="w-full" />
                        </ReferenceInput>
                        <ReferenceInput source="bom_id" reference="boms">
                            <AutocompleteInput label="Bill of Materials" className="w-full" />
                        </ReferenceInput>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-4">
                        <PrioritySelectInput
                            source="priority"
                            label="Priority"
                            defaultValue="medium"
                            validate={required()}
                            choices={[
                                { id: 'low', name: 'Low' },
                                { id: 'medium', name: 'Medium' },
                                { id: 'high', name: 'High' },
                                { id: 'urgent', name: 'Urgent' },
                            ]}
                            className="w-full"
                        />
                        <ReferenceInput source="assigned_to" reference="sales">
                            <AutocompleteInput label="Assign To" className="w-full" optionText={(record: any) => record ? `${record.first_name} ${record.last_name}` : ''} />
                        </ReferenceInput>
                    </div>
                </CardContent>
            </Card>

            <Card className="w-full shadow-sm">
                <CardHeader className="pb-3 border-b">
                    <div className="flex items-center gap-2">
                        <Calendar className="w-5 h-5 text-muted-foreground" />
                        <CardTitle className="text-lg font-semibold tracking-tight">Schedule & Specs</CardTitle>
                    </div>
                </CardHeader>
                <CardContent className="pt-6">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <DateInput source="start_date" label="Start Date" validate={required()} />
                        <DateInput source="target_completion" label="Target Completion" />
                    </div>
                    <div className="mt-4">
                        <TextInput source="production_specs" label="Production Specifications" multiline rows={4} className="w-full" />
                    </div>
                    <div className="mt-4">
                        <TextInput source="notes" label="Notes" multiline rows={2} className="w-full" />
                    </div>
                </CardContent>
            </Card>

            <div className="hidden">
                <TextInput source="status" defaultValue="open" />
                <TextInput source="qa_status" defaultValue="pending" />
            </div>
        </SimpleForm>
    </Create>
);
